import CuotitasSlogan from "../assets/CuotitasLogo.png";
import CuotitasLogo from "../assets/Cuotitashada.png";
import CuotaYaLogo from "../assets/cuotaya-logo.png";
import CuotaYaLogoWhite from "../assets/CuotaYaLogo.webp";
import MobileImg from "../assets/MobileRequired.png";

// THEME (CUOTITAS/CUOTAYA)

const theme = {
    light: "#F3F5F9",
    background: "#F3F5F9",
    primary: "#2F4F83",
    accent: "#F0C23B",
    logo: CuotitasLogo,
    logoSlogan: CuotitasSlogan,
    secondaryLogo: CuotitasLogo,
    mobileRequired: MobileImg,
};

const secondTheme = {
    light: "#F3F5F9",
    background: "#FFF",
    primary: "#d2393e",
    accent: "#bd3739",
    logo: CuotaYaLogo,
    logoSlogan: CuotaYaLogo,
    secondaryLogo: CuotaYaLogoWhite,
    mobileRequired: MobileImg,
};

export function getTheme () {
  switch (window.location.hostname) {
      case process.env.REACT_APP_THEME_CUOTITAS_HOST:
          document.title = 'Cuotitas-Sign';
          return theme;
      case process.env.REACT_APP_THEME_CUOTAYA_HOST:
          document.title = 'CuotaYa-Sign';
          return secondTheme;
        case process.env.REACT_APP_THEME_DEMO_HOST:
            document.title = 'Demo-Sign';
            return secondTheme;
      default:
          return theme;
  }
};